import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TooltipInstructions } from '@app/models';
import { parse } from '@app/shared/helpers/parse.helper';

@Component({
  selector: 'qb-tooltip-modal',
  templateUrl: './tooltip-modal.component.html',
  styleUrls: ['./tooltip-modal.component.scss'],
})
export class TooltipModalComponent implements OnInit {
  instructions: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TooltipInstructions) {}

  ngOnInit(): void {
    this.instructions = parse(this.data.instructions);
  }
}
